// Helper service (as a composable) for storing the "redirection" object used in defaultRedirect.

let _redirection
export function useRedirection () {
  const set = (redirection) => {
    _redirection = redirection
  }

  const get = () => {
    return _redirection
  }

  const clear = () => {
    _redirection = undefined
  }

  return {
    set,
    get,
    clear,
  }
}
